import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { MatTableDataSource } from "@angular/material/table";
import { TypeGarantie } from "./../../models/TypeGarantie";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "app-type-garantie",
  templateUrl: "./type-garantie.component.html",
  styleUrls: ["./type-garantie.component.scss"],
})
export class TypeGarantieComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<TypeGarantie>;
  isLoadingResults = true;

  displayedColumns = [
    "id",
    "codeRule",
    "codeTypeGarantie",
    "libelleTypeGarantie",
    "ponderation",
    "isActive",
    "actions",
  ];
  data: TypeGarantie[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getTypeGaranties();
  }

  getTypeGaranties() {
    this.shared.getTypeGaranties().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  //View row in modal popup

  /*ViewImportPortefeuilleDeatil(row)
  {
    const modalRef = this.modalService.open(ViewItemDetailComponent,
      {
        centered: true, 
        backdropClass: 'light-blue-backdrop',
        backdrop: 'static',
        scrollable: true,
        windowClass: 'my-modal-class'
      });
    modalRef.componentInstance.portefeuilleDetail = row;
    modalRef.componentInstance.importPortefeuilleId = this.importPortefeuilleId;
    
    modalRef.result.then((result) => {
      console.log("result", result);
         // on close
         //this.getImportPortefeuilleDetails(this.importPortefeuilleId);
      }, 
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      });
      
  }
  */
}
